module.exports = __webpack_public_path__ + "static/media/dashboard-content.4c665e32.png";